'use client'
import { useClientBootstrapInit, StatsigProvider } from '@statsig/react-bindings'
import { PropsWithChildren } from 'react'

import { getStatsigOptions } from './statsig-provider.utils'
import { StatsigUserAwareProvider } from './statsig-user-aware'
import { StatsigServerProps } from './statsig.types'

export function StatsigServerProvider({
  statsigServerProps,
  children,
}: PropsWithChildren<{ statsigServerProps: StatsigServerProps }>) {
  const { key, data, serverSideExperiments, statsigUser } = statsigServerProps
  const client = useClientBootstrapInit(key, statsigUser, data, getStatsigOptions())
  return (
    <StatsigProvider client={client}>
      <StatsigUserAwareProvider serverSideExperiments={serverSideExperiments}>{children}</StatsigUserAwareProvider>
    </StatsigProvider>
  )
}
